<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        xl="12"
      >
        <b-form-checkbox
          v-model="groupsChecked"
          :value="true"
          :unchecked-value="false"
        >
          {{ $t('forms.allowed.groups') }}
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        xl="12"
      >
        <AllowedSelect
          id="allowedGroupsField"
          :placeholder="placeholder"
          :disabled="!groupsChecked"
          :table="'groups'"
          :options="groups"
          :selected-values="selectedGroups"
        />
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col
        cols="12"
        xl="12"
      >
        <b-form-checkbox
          v-model="usersChecked"
          :value="true"
          :unchecked-value="false"
        >
          {{ $t('forms.allowed.users') }}
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        xl="12"
      >
        <AllowedSelect
          id="allowedUsersField"
          :placeholder="placeholder"
          :disabled="!usersChecked"
          :table="'users'"
          :options="users"
          :selected-values="selectedUsers"
        />
      </b-col>
    </b-row>
    <template v-if="showDeployments">
      <b-row class="mt-4">
        <b-col
          cols="12"
          xl="12"
        >
          <b-form-checkbox
            v-model="deploymentsChecked"
            :value="true"
            :unchecked-value="false"
          >
            {{ $t('forms.allowed.deployments') }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          xl="12"
        >
          <AllowedSelect
            id="allowedDeploymentsField"
            :placeholder="placeholder"
            :disabled="!deploymentsChecked"
            :table="'deployments'"
            :options="deployments"
            :selected-values="selectedDeployments"
          />
        </b-col>
      </b-row>
    </template>
  </div>
</template>
<script>
import { computed, watch } from '@vue/composition-api'
import { mapGetters } from 'vuex'
import AllowedSelect from '@/components/AllowedSelect.vue'
import i18n from '@/i18n'

export default {
  components: {
    AllowedSelect
  },
  props: {
    showDeployments: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const $store = context.root.$store
    const placeholder = context.root.$route.name === 'deploymentsnew' ? i18n.t('forms.allowed.placeholder') : `${i18n.t('forms.allowed.placeholder')} ${i18n.t('forms.allowed.empty')}`

    // Groups
    const groupsChecked = computed({
      get: () => $store.getters.getGroupsChecked,
      set: (value) => $store.commit('setGroupsChecked', value)
    })
    const groups = computed(() => $store.getters.getGroups)
    const selectedGroups = computed(() => $store.getters.getSelectedGroups)
    // Reset the dropdown when unchecking
    watch(groupsChecked, (checked, prevVal) => {
      if (checked === false) {
        $store.dispatch('updateOptions', { table: 'groups', selected: [] })
        $store.dispatch('updateSelected', { table: 'groups', selected: [] })
      }
    }, { immediate: true })

    // Users
    const usersChecked = computed({
      get: () => $store.getters.getUsersChecked,
      set: (value) => $store.commit('setUsersChecked', value)
    })
    const users = computed(() => $store.getters.getUsers)
    const selectedUsers = computed(() => $store.getters.getSelectedUsers)
    // Reset the dropdown when unchecking
    watch(usersChecked, (checked, prevVal) => {
      if (checked === false) {
        $store.dispatch('updateOptions', { table: 'users', selected: [] })
        $store.dispatch('updateSelected', { table: 'users', selected: [] })
      }
    }, { immediate: true })

    // Deployments
    const deploymentsChecked = computed({
      get: () => $store.getters.getDeploymentsChecked,
      set: (value) => $store.commit('setDeploymentsChecked', value)
    })
    const deployments = computed(() => $store.getters.getDeployments)
    const selectedDeployments = computed(() => $store.getters.getSelectedDeployments)
    // Reset the dropdown when unchecking
    watch(deploymentsChecked, (checked, prevVal) => {
      if (checked === false) {
        $store.dispatch('updateOptions', { table: 'deployments', selected: [] })
        $store.dispatch('updateSelected', { table: 'deployments', selected: [] })
      }
    }, { immediate: true })

    return {
      groups,
      selectedGroups,
      groupsChecked,
      users,
      selectedUsers,
      usersChecked,
      deployments,
      selectedDeployments,
      deploymentsChecked,
      placeholder
    }
  },
  computed: {
    ...mapGetters([
      'getGroups',
      'getUsers',
      'getDeployments'
    ])
  }
}
</script>
